export interface FitterManager {
  email: string;
  fitterComment?: string;
  lastName?: string;
  firstName?: string;
  accessTypes?: FitterAccessType[];
}

export enum FitterAccessTypeEnum {
  grpFitterSuperAdmin = 'grpFitterSuperAdmin',
  grpFitterAdmin = 'grpFitterAdmin',
  grpFitterDashboard = 'grpFitterDashboard',
  grpFitterSearch = 'grpFitterSearch',
  grpFitterParam = 'grpFitterParam',
  grpFitter_franceparebrise = 'grpFitter_franceparebrise',
  grpFitter_default = 'grpFitter_default',
  grpFitter_glassdrive = 'grpFitter_glassdrive',
  grpFitter_aplusglass = 'grpFitter_aplusglass',
  grpFitter_glassautoservice = 'grpFitter_glassautoservice',
  grpFitter_mondialparebrise = 'grpFitter_mondialparebrise',
  grpFitter_actiglass = 'grpFitter_actiglass',
  grpFitter_sekuritpartner = 'grpFitter_sekuritpartner',
  grpFitter_carglass = 'grpFitter_carglass',
}
export type FitterAccessType = `${FitterAccessTypeEnum}`;
